import { FC, Key } from 'react'
import { useMobileDetector } from '../../hooks/use-mobile-detector'
import { isString } from 'formik'
import PdImage from '../pd-image/pd-image'
import ContactButton from '../pd-contact-button/pd-contact-button'
import WatchVideo from '../pd-watch-video/pd-watch-video'
import { HeadingTag } from '../../common/pd-meta-components-types'
import SemanticText from '../standard/semantic-text'
type BannerProps = {
  bgiUri: string
  bgClassName?: string
  bgStyle?: { [key in string]: Key }
  contentClassName?: string
  contentStyle?: { [key in string]: Key }
  titleUri: string
  titleClassName?: string
  titleStyle?: { [key in string]: Key }
  slogan: string
  sloganTag?: HeadingTag
  contactUsPath?: string
  videoUrl?: string
}
const Banner: FC<BannerProps> = ({
  bgiUri,
  bgClassName,
  bgStyle,
  contentClassName,
  contentStyle,
  titleUri,
  titleClassName,
  titleStyle,
  slogan,
  sloganTag,
  contactUsPath,
  videoUrl,
}) => {
  const isMobileDevice = useMobileDetector()

  return (
    <div
      style={{
        backgroundImage: `url(${bgiUri})`,
        ...bgStyle,
      }}
      className={['w-full bg-cover bg-no-repeat bg-center', bgClassName].join(' ')}
    >
      <div style={{ ...contentStyle }} className={['relative flex flex-col items-center', contentClassName].join(' ')}>
        <div style={{ ...titleStyle }} className={['mb-[3.2vw] laptop:mb-[0.8333vw]', titleClassName].join(' ')}>
          <PdImage src={titleUri} object="contain" width="100%" height="100%" enableMask={false} priority={true} />
        </div>
        <SemanticText
          as={sloganTag}
          defaultTag="p"
          className={[
            'text-white/90 text-[4.266vw] laptop:text-[1.25vw] leading-[6.4vw] laptop:leading-loose mb-[6.4vw] laptop:mb-[1.25vw]',
          ].join(' ')}
        >
          {slogan}
        </SemanticText>
        <div className="flex gap-[3.2vw] laptop:gap-[0.8333vw]">
          {contactUsPath && (
            <ContactButton
              className="px-[3.2vw] py-[2.13vw] laptop:px-[0.8333vw] laptop:py-[0.4166vw]"
              textClassName={'text-[3.73vw] laptop:text-[0.73vw]'}
              href={contactUsPath}
            />
          )}
          {videoUrl && (
            <WatchVideo
              className="px-[3.2vw] py-[2.13vw] laptop:px-[0.8333vw] laptop:py-[0.4166vw]"
              textClassName={'text-[3.73vw] laptop:text-[0.73vw]'}
              videoUrl={videoUrl}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Banner
